import React, { useState } from 'react';
import { SearchMetadata } from '../../types/chat';

interface SearchResultsDisplayProps {
  searchMetadata: SearchMetadata;
}

const SearchResultsDisplay: React.FC<SearchResultsDisplayProps> = ({ searchMetadata }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!searchMetadata || (!searchMetadata.queries?.length && !searchMetadata.results?.length)) {
    return null;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="mt-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <button
        onClick={toggleExpanded}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors rounded-lg"
      >
        <div className="flex items-center space-x-2">
          <span className="text-gray-500 dark:text-gray-400">🔍</span>
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            検索結果 ({searchMetadata.results?.length || 0}件)
          </span>
          {searchMetadata.duration_ms > 0 && (
            <span className="text-xs text-gray-500 dark:text-gray-400">
              ({(searchMetadata.duration_ms / 1000).toFixed(1)}秒)
            </span>
          )}
        </div>
        <span className="text-gray-500 dark:text-gray-400">
          {isExpanded ? '▼' : '▶'}
        </span>
      </button>

      {isExpanded && (
        <div className="px-4 pb-4">
          {/* 検索クエリ */}
          {searchMetadata.queries?.length > 0 && (
            <div className="mb-3">
              <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2">
                検索クエリ:
              </h4>
              <div className="space-y-1">
                {searchMetadata.queries.map((query, index) => (
                  <div key={query.query_id || index} className="text-sm text-gray-700 dark:text-gray-300">
                    • {query.text}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 検索結果 */}
          {searchMetadata.results?.length > 0 && (
            <div>
              <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2">
                検索結果:
              </h4>
              <div className="space-y-3">
                {searchMetadata.results.map((result, index) => (
                  <div
                    key={`${result.query_id}-${result.rank}-${index}`}
                    className="bg-white dark:bg-gray-900 rounded-md p-3 border border-gray-200 dark:border-gray-700"
                  >
                    <a
                      href={result.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                    >
                      <h5 className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline mb-1">
                        {result.title}
                      </h5>
                      <p className="text-xs text-gray-600 dark:text-gray-400 line-clamp-2">
                        {result.snippet}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-500 mt-1 truncate">
                        {result.url}
                      </p>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* エラー表示 */}
          {searchMetadata.error && (
            <div className="mt-3 text-sm text-red-600 dark:text-red-400">
              エラー: {searchMetadata.error}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchResultsDisplay;